import React from "react";
import { Link } from "react-router-dom";
import { useLang, UI } from "@/lib/lang";

export default function Footer({ brand }) {
  const { t } = useLang();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#070708] border-t border-white/10 py-16 md:py-24 overflow-hidden"
    >
      <div className="absolute inset-0 grid-blueprint opacity-25" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 md:px-14">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-6">
            <img
              src={brand?.logo}
              alt={brand?.name}
              className="h-24 md:h-32 w-auto"
            />
          </div>
          <div className="col-span-6 md:col-span-3 space-y-3">
            <p className="num-tick text-white/40 mb-3">{t(UI.footerContact)}</p>
            <a
              href={`tel:${(brand?.phone || "").replace(/\s/g, "")}`}
              className="block text-white text-lg hover:text-[#1E7FFF]"
              data-testid="footer-phone"
            >
              {brand?.phone}
            </a>
            <a
              href={`https://wa.me/1${(brand?.whatsapp || "").replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white text-lg hover:text-[#25D366]"
              data-testid="footer-whatsapp"
            >
              WA {brand?.whatsapp_display}
            </a>
            {brand?.email && (
              <a
                href={`mailto:${brand.email}`}
                className="block text-white/70 hover:text-white break-all"
              >
                {brand.email}
              </a>
            )}
          </div>
          <div className="col-span-6 md:col-span-3 space-y-3">
            <p className="num-tick text-white/40 mb-3">{t(UI.footerNav)}</p>
            <a href="#services" className="block text-white/70 hover:text-white">
              {t(UI.navServices)}
            </a>
            <a href="#manifesto" className="block text-white/70 hover:text-white">
              {t(UI.navMethod)}
            </a>
            <a href="#work" className="block text-white/70 hover:text-white">
              {t(UI.navWork)}
            </a>
            <a href="#contact" className="block text-white/70 hover:text-white">
              {t(UI.navContact)}
            </a>
            <Link
              to="/admin"
              className="block text-white/40 hover:text-[#1E7FFF] text-sm mt-6"
              data-testid="footer-admin-link"
            >
              Admin →
            </Link>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 num-tick text-white/40">
          <p>© {new Date().getFullYear()} {brand?.name} · {t(UI.footerRights)}</p>
          <p>{t(brand?.location)} · {t(UI.footerSince)} {brand?.since}</p>
        </div>
      </div>
    </footer>
  );
}
